import { Snackbar } from '@mui/material';
import React, { useCallback, useContext } from 'react';

import Alert from '@mui/material/Alert';
import { AlertColor } from '@mui/material/Alert/Alert';
import { ISnacksProps, SnackBarType } from './interfaces/ISnacksProps';
import { SnackbarContext } from './SnackbarContext';

export const NoraSnackbarView = () => {
  const { openSnacks, setSnacks } = useContext(SnackbarContext);

  const handleOnClose = useCallback(
    (snack: ISnacksProps) => {
      const updatedSnacks = openSnacks.filter(({ id }) => id !== snack.id);
      setSnacks(updatedSnacks);
    },
    [openSnacks, setSnacks],
  );

  return (
    <>
      {openSnacks.map(snack => (
        <Snackbar
          autoHideDuration={snack.autoHideDuration}
          key={snack.id}
          open
          onClose={() => handleOnClose(snack)}
        >
          <Alert
            onClose={() => handleOnClose(snack)}
            severity={getAlertSeverity(snack.type)}
            variant="filled"
          >
            {snack.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

const getAlertSeverity = (type: SnackBarType): AlertColor => {
  switch (type) {
    case SnackBarType.INFO:
      return 'info';
    case SnackBarType.ALERT:
      return 'error';
    case SnackBarType.SUCCESS:
      return 'success';
    case SnackBarType.UNKNOWN:
      return 'info';
    default:
      return 'info';
  }
};
